<template>
  <!-- O COMPONENTE NÃO POSSUI VALIDAÇÕES (COMPRIMENTO E SEQUÊNCIA VÁLIDA) POIS ACEITA COMPRIMENTO PARCIAL -->
  <NxInput
    name="document"
    type="text"
    label="CPF/CNPJ:"
    placeholder="Digite o CPF ou CNPJ"
    v-mask="['###.###.###-##', '##.###.###/####-##']"
    :value="localValue"
    @update:value="handleValueUpdate"
  ></NxInput>
</template>
<script>
import { useReactiveModelMixin } from '../../mixins'
export default {
  name: 'NxInputDocument',
  mixins: [useReactiveModelMixin('value')],
  methods: {
    handleValueUpdate (val) {
      this.localValue = val
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nexum/components/custom-inputs/NxInputDocument.vue